import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import "./style.css";
export function BounceLoader({ style, className }) {
  return /* @__PURE__ */ jsxs("div", { className: classNames("tg-bounce-loader", className), style, children: [
    /* @__PURE__ */ jsx("div", { className: "rect1" }),
    /* @__PURE__ */ jsx("div", { className: "rect2" }),
    /* @__PURE__ */ jsx("div", { className: "rect3" }),
    /* @__PURE__ */ jsx("div", { className: "rect4" }),
    /* @__PURE__ */ jsx("div", { className: "rect5" })
  ] });
}
